'use strict';

class CouponComponent {
    constructor (selector) {
        this.$card = $(selector);
        this.$header = this.$card.find('.card-header');
        this.opener = '#add-coupon-code';
        this.input = '#couponCode';
        this.submit = '[type="submit"]';
    }

    drawer () {
        this.$card.find(this.$header).on('click', (e) => {
            this.$header.toggleClass('active');
            this.$card.addClass('active');
            $('.js-code-input').stop().slideToggle();
        });
    }

    input () {
        this.$card.on('keyup', this.input, (e) => {
            this.$card.find(this.submit).attr('disabled', $(e.currentTarget).val().length === 0);
        });

        var _card = this.$card;
        var _submit = this.submit;
        this.$card.on('paste', this.input, (e) => {
            setTimeout(function () {
                _card.find(_submit).attr('disabled', $(e.currentTarget).val().length === 0);
            }, 250);
        });
    }
}

export default class Coupon extends CouponComponent {
    run () {
        super.drawer();
        super.input();
    }
}
